// Terminal project statuses. `project_status` is an admin-managed lookup
// (migration 0037), so an admin can add codes we've never heard of — those are
// treated as live, which is the safe default. This is a code-specific list in
// the same spirit as the `.status-*` CSS classes; see the ProjectStatus note in
// shared-types.
//
// `POST /api/projects/:id/archive` sets status='closed', and 'archived' is
// seeded is_active=FALSE (so it isn't offered in the dropdown) but can still be
// stored on a row, hence both.
export const CLOSED_PROJECT_STATUSES: readonly string[] = ['closed', 'archived'];

export function isClosedProject(p: { status: string }): boolean {
  return CLOSED_PROJECT_STATUSES.includes(p.status);
}

/**
 * Split a project list into live and finished work, preserving the order the
 * API returned (`case_number DESC`) within each half.
 *
 * Generic over the row, not `Project`: the list endpoint denormalizes
 * `client_name`/`client_company_name` onto each row, and typing this as
 * `Project[]` would narrow those away at every call site.
 */
export function partitionByClosed<T extends { status: string }>(projects: readonly T[]): {
  active: T[];
  closed: T[];
} {
  const active: T[] = [];
  const closed: T[] = [];
  for (const p of projects) (isClosedProject(p) ? closed : active).push(p);
  return { active, closed };
}
